<template>
  <Modal size="big" :title="isCancel ? '予約キャンセル' : '予約確定'" :staticFooter="isSP" @close="close">
    <template #content>
      <div class="contents">
        <div class="reserve-cancellation">
          <p class="head-text">
            <span>
              {{ confirmed ? '' : 'リクエスト' }}予約を{{ isCancel ? 'キャンセル' : '確定' }}します。
              {{ isCancel ? 'キャンセル理由を選択してください。' : '' }}
            </span>
            <span v-if="!(isOzmall || isRetty)">
              お客様へのメッセージを追加する方は、{{ isCancel ? '下部メッセージに' : '以下より' }}入力してください。
            </span>
            <span v-if="isOzmall">カード決済・無断キャンセルの場合は媒体管理画面から操作してください。</span>
          </p>
          <dl v-if="isCancel" class="cancel-reason">
            <dt>
              <b>キャンセル理由</b>
              <RequiredLabel />
            </dt>
            <dd>
              <SelectBox v-model.number="reason" :items="reasons" class="sp-reason">
                <option value="" disabled selected>理由を選択してください</option>
              </SelectBox>
              <PopoverSelectBox
                class="reason"
                v-model.number="reason"
                :items="reasons"
                placeholder="理由を選択してください"
              >
                <template v-if="isGnavi" #beforeItem="{ index }">
                  <div v-if="index === 0" class="label">お客様の都合：</div>
                  <template v-else-if="index === (isConfirmedGnaviAfterPeriod ? 3 : 2)">
                    <hr />
                    <div class="label">お店の都合：</div>
                  </template>
                  <template v-else-if="isConfirmedGnaviAfterPeriod ? false : index === 5">
                    <hr />
                    <div class="label">その他：</div>
                  </template>
                </template>
              </PopoverSelectBox>
            </dd>
          </dl>
        </div>
        <div class="mail-area">
          <dl>
            <dt>
              <p class="heading">メッセージ<RequiredLabel v-if="requireMessage" /></p>
            </dt>
            <dd v-if="messageNote" class="note">{{ messageNote }}</dd>
            <dd>
              <label class="message-area">
                <TextArea
                  v-model="message"
                  placeholder="ここにメッセージを入力してください。"
                  :disabled="isOzmall || isRetty || isConfirmedGnaviAfterPeriod"
                />
              </label>
            </dd>
          </dl>
          <template v-if="isSP">
            <dl class="sp-sendmail">
              <Popover
                class="stafflist"
                placement="top-start"
                :open="isShowStaffList"
                :disabled="!isShowStaffList"
                @auto-hide="isShowStaffList = false"
              >
                <StaffSelect slot="popover" :staff-list="staffList" @select="selectStaff" />
                <Button primary :disabled="invalid || isShowStaffList" @click="onClickConfirm">
                  {{ isCancel ? '予約キャンセル' : '予約確定' }}
                </Button>
              </Popover>
            </dl>
          </template>
        </div>
      </div>
    </template>
    <template v-if="!isSP" #footer-center>
      <div class="buttons">
        <Button class="sp-hide" @click="close">戻る</Button>
        <Popover
          class="stafflist"
          placement="top-start"
          :open="isShowStaffList"
          :disabled="!isShowStaffList"
          @auto-hide="isShowStaffList = false"
        >
          <StaffSelect slot="popover" :staff-list="staffList" @select="selectStaff" />
          <Button primary :disabled="invalid || isShowStaffList" @click="onClickConfirm">
            {{ isCancel ? '予約キャンセル' : '予約確定' }}
          </Button>
        </Popover>
      </div>
    </template>
  </Modal>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import { formatDate, toHourClock, today } from '@/utils/date'
import TextArea from '@/components/atoms/TextArea'
import Popover from '@/components/molecules/Popover'
import PopoverSelectBox from '@/components/molecules/PopoverSelectBox'
import StaffSelect from '@/components/molecules/StaffSelect'
import Modal from '@/components/molecules/Modal'
import Button from '@/components/atoms/Button'
import SelectBox from '@/components/atoms/SelectBox'
import RequiredLabel from '@/components/molecules/RequiredLabel'

export default {
  name: 'ResrakuMessageModal',
  components: {
    TextArea,
    Popover,
    PopoverSelectBox,
    StaffSelect,
    Modal,
    Button,
    SelectBox,
    RequiredLabel,
  },
  props: {
    isCancel: { type: Boolean, default: false },
    selectedIds: { type: Array, default: () => [] },
    isResrakuReserve: { type: Object, default: () => {} },
    isConfirmedResrakuReserve: { type: Object, default: () => {} },
    backTo: String,
  },
  data() {
    return {
      reason: null,
      message: '',
      isShowStaffList: false,
    }
  },
  computed: {
    ...mapState({
      isSP: state => state.app.isSP,
      reserve: state => state.reserves.detail.reservation,
      edit: state => state.reserves.edit,
      reservesView: state => state.stores.current.store.reservesView,
    }),
    ...mapGetters({
      staffList: 'staffs/all',
    }),
    isGnavi() {
      return this.reserve.syncType === 4
    },
    isTabelog() {
      return this.reserve.syncType === 9
    },
    isOzmall() {
      return this.reserve.syncType === 14
    },
    isRetty() {
      return this.reserve.syncType === 16
    },
    confirmed() {
      return this.isConfirmedResrakuReserve?.confirmed
    },
    deny() {
      // ぐるなびネット予約
      const gnavi = new Map([
        [1, 'お客様からキャンセルのご連絡があった'],
        [2, '必要な確認事項が発生したが、お客様と連絡が取れない'],
        [3, '席をご用意できない'],
        [4, '来店日が休店日もしくは貸切'],
        [5, '当店の都合によるキャンセルを電話・メッセージで合意した'],
        [6, 'その他（メッセージを入力してください）'],
      ])

      // ホットペッパー
      const hotpepper = new Map([
        [20, 'お客様都合'],
        [10, '貴店都合'],
        [21, '無断キャンセル'],
      ])

      // retty
      const retty = new Map([
        [1, 'お店都合'],
        [2, 'お客様都合（キャンセル連絡あり）'],
        [3, 'お客様都合（キャンセル連絡なし）'],
        [4, 'お客様の予定がなくなったため'],
        [5, 'お客様が予約内容を変更したため'],
        [6, 'お客様が他のお店を予約したため'],
        [8, 'その他'],
      ])
      if (this.reserveDatetime.date >= today()) {
        hotpepper.delete(21)
        retty.delete(3)
      }

      const reason = {
        4: gnavi,
        10: hotpepper,
        16: retty,
      }
      return reason[this.reserve.syncType]
    },
    cancel() {
      const { gnavi, tabelog, hotpepper, retty } = this.isConfirmedResrakuReserve
      // ぐるなびネット予約
      const gnaviReason = new Map([
        [1, 'お客様からキャンセルのご連絡があった'],
        [2, '必要な確認事項が発生したが、お客様と連絡が取れない'],
        [8, '来店時間になったが、お客様が来店されなかった'],
        [3, '席をご用意できない'],
        [4, '来店日が休店日もしくは貸切'],
        [5, '当店の都合によるキャンセルを電話・メッセージで合意した'],
        [6, 'その他（メッセージを入力してください）'],
      ])
      if (gnavi === 2) gnaviReason.delete(8)
      if (this.isConfirmedGnaviAfterPeriod) gnaviReason.delete(6)

      // 食べログ
      const tabelogReason = new Map([
        [0, 'キャンセル'],
        [1, '連絡なしキャンセル処理'],
        [2, '店舗都合のキャンセルの場合'],
      ])
      if (tabelog === 2) tabelogReason.delete(1)

      // ホットペッパー
      const hotpepperReason = new Map([
        [20, 'お客様都合'],
        [10, '貴店都合'],
        [21, '無断キャンセル'],
      ])
      if (hotpepper === 2) hotpepperReason.delete(21)

      // ozmall
      const ozmallReason = new Map([[0, 'キャンセル']])

      // retty
      const rettyReason = new Map([
        [1, 'お店都合'],
        [2, 'お客様都合（キャンセル連絡あり）'],
        [3, 'お客様都合（キャンセル連絡なし）'],
        [4, 'お客様の予定がなくなったため'],
        [5, 'お客様が予約内容を変更したため'],
        [6, 'お客様が他のお店を予約したため'],
        [8, 'その他'],
      ])
      if (retty === 2) rettyReason.delete(3)

      const reason = {
        4: gnaviReason,
        9: tabelogReason,
        10: hotpepperReason,
        14: ozmallReason,
        16: rettyReason,
      }

      return reason[this.reserve.syncType]
    },
    reasons() {
      return this.confirmed ? this.cancel : this.deny
    },
    reserveDatetime() {
      return toHourClock(this.reserve.reserveDatetime)
    },
    messageNote() {
      const note = {
        4: '※1000文字まで入力可。',
        9: '※200文字まで入力可。',
        10: '※1000文字まで入力可。\n※改行なしで1行300文字を超える場合はエラーとなります。',
      }
      return note[this.reserve.syncType]
    },
    messageMaxLength() {
      return this.isTabelog ? 200 : 1000
    },
    requireMessage() {
      return this.isGnavi && this.reason === 6
    },
    invalid() {
      return (
        (this.isCancel && (this.reason === null || (this.requireMessage && !this.message.length))) ||
        this.message.length > this.messageMaxLength
      )
    },
    isConfirmedGnaviAfterPeriod() {
      return this.isConfirmedResrakuReserve?.gnavi === 3
    },
  },
  methods: {
    async onClickConfirm() {
      if (this.staffList.length > 1) {
        this.isShowStaffList = true
      } else {
        this.selectStaff(this.staffList[0])
      }
    },
    selectStaff(staff) {
      this.isShowStaffList = false
      this.sendRequest({ staff })
    },
    async sendRequest({ staff }) {
      const { dispatch } = this.$store
      let action
      if (this.confirmed) {
        action = 'resraku/request/cancel'
      } else {
        action = this.isCancel ? 'resraku/request/deny' : 'resraku/request/accept'
      }
      const baseRequest = {
        rsvId: this.reserve.id,
        staffId: staff.id,
        reasonMessage: this.message,
      }
      const tableIds = this.selectedIds.length ? this.selectedIds : this.edit.reservation.tableIds
      const additional =
        this.isCancel || this.confirmed ? { reasonType: this.reason } : { tableList: tableIds.sort().join() }
      if (await dispatch(action, { ...baseRequest, ...additional })) {
        this.close()
        if (this.isSP) {
          this.backTo
            ? location.assign(`/sp/reserve/${this.reserve.id}`)
            : location.assign(`/sp?date=${formatDate(this.reserveDatetime.date, 'YYYYMMDD')}`)
        } else {
          location.assign(`/reservation/${this.reservesView}?date=${formatDate(this.reserveDatetime.date, 'YYYYMMDD')}`)
        }
      }
    },
    close() {
      this.isShowStaffList = false
      this.$emit('close')
    },
  },
}
</script>

<style lang="postcss" scoped>
.contents {
  .responsive & {
    @media screen and (--sp-modal) {
      box-sizing: border-box;
      grid-gap: 24px;
      height: 100%;
      width: 100%;
    }
  }

  .reserve-cancellation {
    display: grid;
    grid-gap: 8px;
    padding: 16px 24px;

    .head-text {
      font-size: 13px;
      line-height: 19px;

      span {
        display: inline-block;
      }
    }

    .cancel-reason {
      margin-top: 8px;
    }

    dl {
      display: grid;
      grid-gap: 8px;

      dt {
        align-items: center;
        display: grid;
        grid-auto-flow: column;
        grid-gap: 8px;
        justify-content: flex-start;
        line-height: 1;
      }

      .reason {
        /* TODO >>> を無くしたい */
        >>> .field {
          width: 432px;
        }
      }

      .sp-reason {
        display: none;
      }
    }

    .desc {
      font-size: 11px;
      line-height: 16px;
    }

    .responsive & {
      @media screen and (--sp-modal) {
        grid-gap: 16px;
        padding: 16px 16px 24px;

        .head-text {
          font-size: 15px;
          line-height: 21px;
        }

        .cancel-reason {
          .reason {
            display: none;
          }

          .sp-reason {
            display: block;

            >>> select {
              overflow: hidden;
            }

            option:disabled {
              display: none;
            }
          }
        }
      }
    }
  }

  .mail-area {
    background-color: var(--mostly-white);
    border-top: 1px solid var(--very-light-gray-2);
    display: grid;
    grid-gap: 16px;
    padding: 16px 24px 24px;

    dl {
      display: grid;
      grid-gap: 8px;

      dt {
        line-height: 1;
      }
    }

    hr {
      background-color: var(--very-light-gray-2);
      border: none;
      display: none;
      height: 1px;
      margin: 0;
      width: 100%;
    }

    .heading {
      font-weight: 600;

      span {
        margin-left: 4px;
      }
    }

    .note {
      font-size: 11px;
      white-space: pre-line;
    }

    .message-area {
      background-color: var(--white);
      border: 1px solid var(--border-color);
      border-radius: 4px;
      box-sizing: border-box;
      display: block;
      height: 256px;
      overflow-y: scroll;

      textarea {
        border: 0;
        min-height: 256px;
        padding: 16px;

        &:focus {
          border: 0;
        }
      }
    }

    .sp-sendmail {
      display: none;

      button {
        border-radius: 4px;
        font-size: 15px;
        height: 40px;
        line-height: normal;
        width: 100%;
      }

      .stafflist {
        width: 100%;
      }
    }

    .responsive & {
      @media screen and (--sp-modal) {
        border-top: none;
        padding: 24px 16px;

        hr {
          display: initial;
        }

        .heading {
          font-size: 18px;
        }

        .message-area {
          height: 160px;
          transform: translate3d(0, 0, 0);

          textarea::placeholder {
            color: var(--light-gray);
          }
        }

        .sp-sendmail {
          display: initial;
        }
      }
    }
  }
}

.label {
  color: var(--dark-gray);
  font-size: 13px;
  padding: 8px 16px;
}

.buttons {
  display: grid;
  grid-gap: 16px 32px;
  grid-template-columns: 1fr 1fr;
  justify-items: center;

  .responsive & {
    @media screen and (--sp-modal) {
      grid-template-columns: 1fr;
      padding: 8px;

      .sp-hide {
        display: none;
      }

      .stafflist {
        width: 100%;
      }
    }
  }
}

.button {
  width: 184px;
}
</style>
